<hyperkit-dialog class="hyperkit-component" headerText="API Key Created">
  <div id="simple-page">
    <main>
      <div>
        <hyperkit-typography
          variant="body"
          size="md"
          align="center"
          color="body"
        >
          Make sure you copy <strong>{{ data.keyName }}</strong> as it won't be
          shown again.</hyperkit-typography
        >
      </div>
      <div class="key">
        <hyperkit-typography
          variant="monospace"
          size="md"
          color="primary"
          display="inline"
          >{{ data.apiKey }}</hyperkit-typography
        >
        @if (!copied) {
          <hyperkit-icon
            [icon]="copyIcon"
            size="medium"
            color="primary"
            class="copy-icon"
            (click)="writeToClipboard(data.apiKey)"
          ></hyperkit-icon>
        } @else {
          <hyperkit-icon
            [icon]="checkIcon"
            size="medium"
            color="success"
            class="copy-icon"
          ></hyperkit-icon>
        }
      </div>
      <hyperkit-button
        size="medium"
        color="tertiary"
        text="Close"
        (click)="onClose()"
      ></hyperkit-button>
    </main>
  </div>
</hyperkit-dialog>
